import React, { useState } from 'react'

export default function ToggableDt({
  children,
  expanded: initialExpanded = false,
}: {
  children: any
  expanded?: boolean
}) {
  const [expanded, setExpanded] = useState(initialExpanded)

  return (
    <dt
      aria-expanded={expanded}
      onClick={() => setExpanded(!expanded)}
      className={expanded ? 'open' : undefined}
    >
      {children}
    </dt>
  )
}
